import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { subscribe } from '../lib/toast.js';

// Renders queued toasts in a fixed top-right stack via a portal to
// document.body so they sit above modals. Mounted once at the app root.
export default function ToastHost() {
  const [toasts, setToasts] = useState([]);
  const timers = useRef(new Map());

  function dismiss(id) {
    setToasts((prev) => prev.filter((t) => t.id !== id));
    const h = timers.current.get(id);
    if (h) { clearTimeout(h); timers.current.delete(id); }
  }

  useEffect(() => {
    const unsub = subscribe((t) => {
      setToasts((prev) => [...prev, t]);
      if (t.duration && t.duration > 0) {
        const h = setTimeout(() => dismiss(t.id), t.duration);
        timers.current.set(t.id, h);
      }
    });
    const map = timers.current;
    return () => { unsub(); for (const h of map.values()) clearTimeout(h); map.clear(); };
  }, []);

  if (toasts.length === 0) return null;

  return createPortal(
    <div className="toast-host" aria-live="polite" aria-atomic="false">
      {toasts.map((t) => (
        <div key={t.id} className={`toast toast-${t.tone}`} role="status">
          <div className="toast-content">
            {t.title && <div className="toast-title">{t.title}</div>}
            {t.body && <div className="toast-body">{t.body}</div>}
          </div>
          <button type="button" className="toast-close" onClick={() => dismiss(t.id)} aria-label="Dismiss notification">×</button>
        </div>
      ))}
    </div>,
    document.body
  );
}
